import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import api from "../api/axios";

export default function WalletPage() {
  const { wallet, setWallet, transactions } = useContext(UserContext);
  // const { wallet, setWallet, crypto, setCrypto, transactions, setTransactions } = useContext(UserContext);
  const navigate = useNavigate();

  /* const [cryptoForm, setCryptoForm] = useState({
    coin: "BTC",
    walletAddress: "",
    network: "",
    amount: "",
    type: "deposit",
  }); */

  const cardClass = "rounded-[2rem] border border-white/10 bg-slate-900/75 p-6 backdrop-blur-xl";

  /* const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => setMessage("Address copied to clipboard."))
      .catch(() => setError("Failed to copy address."));
  }; */

  // ----- Fetch wallet balance -----
  useEffect(() => {
    const fetchWallet = async () => {
      try {
        const walletRes = await api.get("/wallet");

        /* const [walletRes, bankRes, cryptoHistoryRes, cryptoBalancesRes] = await Promise.all([
          api.get("/wallet"),
          api.get("/bank"),
          api.get("/crypto/history"),
          api.get("/crypto/balances"),
        ]);
        const addressResults = await Promise.allSettled([
          api.get("/crypto/deposit-address?network=btc"),
          api.get("/crypto/deposit-address?network=eth"),
          api.get("/crypto/deposit-address?network=tron"),
        ]);
        const [btcAddressRes, ethAddressRes, usdtAddressRes] = addressResults;
        */

        setWallet(walletRes.data);
        /* setCrypto(prev => ({ ...prev, transactions: cryptoHistoryRes.data }));
        setCrypto(prev => ({ ...prev, balances: cryptoBalancesRes.data }));
        setCryptoAddresses({
          BTC: btcAddressRes.status === "fulfilled" ? (btcAddressRes.value.data?.address || "") : "",
          ETH: ethAddressRes.status === "fulfilled" ? (ethAddressRes.value.data?.address || "") : "",
          "USDT (TRC20)": usdtAddressRes.status === "fulfilled" ? (usdtAddressRes.value.data?.address || "") : "",
        }); */
      } catch (err) {
        console.error(err);
      }
    };
    fetchWallet();
  }, [setWallet]);

  // const handleCryptoChange = (e) => setCryptoForm({ ...cryptoForm, [e.target.name]: e.target.value });

  /* const submitCrypto = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    try {
      const endpoint = cryptoForm.type === "deposit" ? "/crypto/deposit" : "/crypto/withdraw";
      const { data } = await api.post(endpoint, cryptoForm);
      setMessage(data.message || "Crypto request submitted.");
      setCryptoForm({ coin: "BTC", walletAddress: "", network: "", amount: "", type: "deposit" });

      setCrypto(prev => ({
        ...prev,
        transactions: [...prev.transactions, data.transaction]
      }));
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Crypto transaction failed");
    }
  }; */

  const monthKeys = Array.from({ length: 6 }, (_, index) => {
    const date = new Date();
    date.setDate(1);
    date.setMonth(date.getMonth() - (5 - index));
    return {
      key: `${date.getFullYear()}-${date.getMonth()}`,
      label: date.toLocaleDateString("en", { month: "short" }),
      incoming: 0,
      outgoing: 0,
      count: 0,
    };
  });
  const activityByMonth = new Map(monthKeys.map((month) => [month.key, month]));

  transactions.forEach((transaction) => {
    if (transaction.status !== "success") return;
    const date = new Date(transaction.createdAt);
    const month = activityByMonth.get(`${date.getFullYear()}-${date.getMonth()}`);
    if (!month) return;

    const amount = Math.abs(Number(transaction.amount) || 0);
    if (transaction.type === "deposit" || (transaction.type === "transfer" && transaction.metadata?.direction === "in")) {
      month.incoming += amount;
      month.count += 1;
    } else if (["withdrawal", "airtime", "data", "bill"].includes(transaction.type) || (transaction.type === "transfer" && transaction.metadata?.direction === "out")) {
      month.outgoing += amount;
      month.count += 1;
    }
  });

  const totalIncoming = monthKeys.reduce((total, month) => total + month.incoming, 0);
  const totalOutgoing = monthKeys.reduce((total, month) => total + month.outgoing, 0);
  const completedCount = monthKeys.reduce((total, month) => total + month.count, 0);
  const netFlow = totalIncoming - totalOutgoing;
  const peakMonthFlow = Math.max(...monthKeys.map((month) => month.incoming + month.outgoing), 1);
  const formatNaira = (amount) => `₦${Math.round(amount).toLocaleString()}`;

  return (
    <div className="space-y-6 text-white">

      {/* Wallet Balance + Fiat Buttons */}
      <section className={`${cardClass} flex flex-col gap-4 md:flex-row md:items-center md:justify-between`}>
        <div>
          <h2 className="mb-2 text-xl font-bold">Wallet Balance</h2>
          <p className="text-3xl font-bold text-cyan-300">₦{Number(wallet.balance || 0).toLocaleString()}</p>
        </div>
        <div className="flex gap-2">
          <button className="rounded-lg bg-emerald-500/20 px-4 py-2 text-emerald-300" onClick={() => navigate("/fund")}>Deposit</button>
          <button className="rounded-lg bg-red-500/20 px-4 py-2 text-red-300" onClick={() => navigate("/send-money")}>Withdraw</button>
        </div>
      </section>

      <section className={`${cardClass} overflow-hidden`}>
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-cyan-300">Wallet insights</p>
            <h2 className="mt-2 text-2xl font-bold">Account growth</h2>
            <p className="mt-1 text-sm text-slate-400">Completed wallet activity over the last six months.</p>
          </div>
          <span className="rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs font-medium text-slate-300">
            {completedCount} completed {completedCount === 1 ? "transaction" : "transactions"}
          </span>
        </div>

        <div className="mt-6 grid gap-3 sm:grid-cols-3">
          <div className="rounded-xl border border-emerald-400/15 bg-emerald-400/[0.06] p-4">
            <p className="text-xs font-medium text-slate-400">Money in</p>
            <p className="mt-2 text-xl font-semibold text-emerald-300">{formatNaira(totalIncoming)}</p>
          </div>
          <div className="rounded-xl border border-rose-400/15 bg-rose-400/[0.06] p-4">
            <p className="text-xs font-medium text-slate-400">Money out</p>
            <p className="mt-2 text-xl font-semibold text-rose-300">{formatNaira(totalOutgoing)}</p>
          </div>
          <div className="rounded-xl border border-cyan-300/15 bg-cyan-300/[0.06] p-4">
            <p className="text-xs font-medium text-slate-400">Net flow</p>
            <p className={`mt-2 text-xl font-semibold ${netFlow >= 0 ? "text-cyan-200" : "text-rose-300"}`}>
              {netFlow < 0 ? "−" : "+"}{formatNaira(Math.abs(netFlow))}
            </p>
          </div>
        </div>

        <div className="mt-8">
          <div className="mb-4 flex items-center gap-5 text-xs text-slate-400">
            <span className="flex items-center gap-2"><span className="h-2 w-2 rounded-full bg-emerald-300" />Money in</span>
            <span className="flex items-center gap-2"><span className="h-2 w-2 rounded-full bg-rose-300" />Money out</span>
          </div>
          <div className="grid grid-cols-6 gap-2 sm:gap-4" role="img" aria-label="Monthly wallet inflow and outflow for the last six months">
            {monthKeys.map((month) => {
              const incomingHeight = month.incoming ? Math.max((month.incoming / peakMonthFlow) * 100, 4) : 0;
              const outgoingHeight = month.outgoing ? Math.max((month.outgoing / peakMonthFlow) * 100, 4) : 0;

              return (
                <div key={month.key} className="min-w-0 text-center">
                  <div className="flex h-36 items-end justify-center gap-1 border-b border-white/10 px-1">
                    <div
                      className="w-3 rounded-t-sm bg-emerald-300/90 transition-[height] duration-500 sm:w-5"
                      style={{ height: `${incomingHeight}%` }}
                      title={`${month.label} money in: ${formatNaira(month.incoming)}`}
                    />
                    <div
                      className="w-3 rounded-t-sm bg-rose-300/80 transition-[height] duration-500 sm:w-5"
                      style={{ height: `${outgoingHeight}%` }}
                      title={`${month.label} money out: ${formatNaira(month.outgoing)}`}
                    />
                  </div>
                  <p className="mt-2 text-xs text-slate-500">{month.label}</p>
                </div>
              );
            })}
          </div>
          {completedCount === 0 && (
            <p className="mt-4 text-center text-sm text-slate-500">Your completed wallet activity will appear here.</p>
          )}
        </div>
      </section>

      {/* Crypto Section */}
      {/*
      <section className={`${cardClass} space-y-4`}>
        <h2 className="text-xl font-bold">Crypto</h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          {Object.entries(crypto.balances).map(([coin, balance]) => (
            <div key={coin} className="rounded-xl border border-white/10 bg-white/5 p-4">
              <h4 className="font-semibold">{coin} Balance</h4>
              <p className="text-lg">{balance}</p>
            </div>
          ))}
        </div>

<div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
  {Object.entries(cryptoAddresses).map(([coin, addr]) => (
    <div key={coin} className="rounded-xl border border-white/10 bg-white/5 p-4 flex flex-col">
      <h4 className="font-semibold">{coin} Address</h4>
      <div className="flex items-center justify-between mt-2">
        <p className="text-sm break-all">{addr}</p>
        <button 
          onClick={() => copyToClipboard(addr)} 
          className="ml-2 rounded-md bg-cyan-300/20 px-2 py-1 text-cyan-300 hover:bg-cyan-300/30"
        >
          Copy
        </button>
      </div>
    </div>
  ))}
</div>


        <form className="grid grid-cols-1 md:grid-cols-2 gap-4" onSubmit={submitCrypto}>
          <select name="coin" className={inputClass} value={cryptoForm.coin} onChange={handleCryptoChange}>
            <option value="BTC">BTC</option>
            <option value="ETH">ETH</option>
            <option value="USDT">USDT</option>
          </select>
          <input name="walletAddress" placeholder="Wallet Address" className={inputClass} value={cryptoForm.walletAddress} onChange={handleCryptoChange} required />
          <input name="network" placeholder="Network" className={inputClass} value={cryptoForm.network} onChange={handleCryptoChange} required />
          <input name="amount" placeholder="Amount" type="number" className={inputClass} value={cryptoForm.amount} onChange={handleCryptoChange} required />
          <select name="type" className={inputClass} value={cryptoForm.type} onChange={handleCryptoChange}>
            <option value="deposit">Deposit</option>
            <option value="withdraw">Withdraw</option>
          </select>
          <button type="submit" className="rounded-xl bg-accent px-4 py-2 font-semibold text-slate-950">Submit</button>
        </form>

        <div>
          <h3 className="mt-4 font-semibold">Crypto History</h3>
          <ul className="mt-2 space-y-2">
            {crypto.transactions.map((c) => (
              <li key={c._id} className="rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-sm text-slate-300">
                {c.coin} - {c.amount} ({c.status})
              </li>
            ))}
          </ul>
        </div>
      </section>
      */}

      {/* Recent Fiat Transactions */}
      <section className={`${cardClass} space-y-4`}>
        <h2 className="text-xl font-bold">Recent Fiat Transactions</h2>
        {transactions.length === 0 && <p className="text-slate-400">No transactions yet.</p>}
        {transactions.length > 0 && (
          <div className="overflow-x-auto">
            <table className="w-full border-separate border-spacing-y-2 text-sm">
              <thead>
                <tr className="text-left text-xs uppercase tracking-wider text-slate-400">
                  <th className="px-3 py-2">#</th>
                  <th className="px-3 py-2">Type</th>
                  <th className="px-3 py-2">Amount (₦)</th>
                  <th className="px-3 py-2">Status</th>
                  <th className="px-3 py-2">Reference</th>
                  <th className="px-3 py-2">Date</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((t, idx) => (
                  <tr key={t._id} className="bg-white/5 text-center">
                    <td className="rounded-l-xl px-3 py-3">{idx + 1}</td>
                    <td className="px-3 py-3 capitalize">{t.type.replace("_", " ")}</td>
                    <td className="px-3 py-3">₦{t.amount.toLocaleString()}</td>
                    <td className={`px-3 py-3 font-semibold ${
                      t.status === "success" ? "text-emerald-400" :
                      t.status === "pending" ? "text-amber-400" : "text-red-400"
                    }`}>{t.status}</td>
                    <td className="px-3 py-3">{t.reference}</td>
                    <td className="rounded-r-xl px-3 py-3">{new Date(t.createdAt).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
}
